import { ShoppingBag, Sparkles, ExternalLink } from "lucide-react";

/**
 * Sister properties — other Jesus Just Us / Naima ministries that live on
 * separate WordPress sites. We cross-link from JJU and brand them as one family.
 *
 * When Option B is ready (CORS or backend whitelisting on the WP hosts), each
 * entry can grow an `endpoint` + a `fetcher` to surface live products/courses.
 */
export const SISTER_SITES = [
  {
    key: "big-deal-big-things",
    name: "Big Deal Big Things",
    tagline: "The Kingdom marketplace",
    description:
      "Faith-led products, gifts, books, and resources — every purchase sows back into Kingdom work.",
    longBlurb:
      "A growing storefront of intentionally curated Kingdom goods — books, gifts, and resources from believers who put Christ at the center of their craft. Browse, support, and bring something beautiful into your home.",
    url: "https://bigdealbigthings.com",
    cta: "Shop the marketplace",
    icon: ShoppingBag,
    accent: "burgundy", // visual accent for the card
    badge: "Marketplace",
  },
  {
    key: "confidence-arise",
    name: "Confidence Arise",
    tagline: "A business builder information hub",
    description:
      "Free e-books, downloads, and practical teaching for any believer building a business — plus services to help you actually get up and running.",
    longBlurb:
      "Confidence Arise is a Christ-centered hub for believers building businesses — no gender required, just a starting point. The site is loaded with free downloadable e-books and resources to grow your knowledge and mindset, and we offer services to help you get from idea to up-and-running.",
    url: "https://confidencearise.com",
    cta: "Open the hub",
    icon: Sparkles,
    accent: "gold",
    badge: "Business builder hub",
  },
];

export { ExternalLink };
